import { atom, useAtom } from "jotai";
import { Slot } from "src/containers/event/event.types";

type SelectedSlotsByEvent = Record<string, Slot[]>;

const slotAtom = atom<SelectedSlotsByEvent>({});
const DEFAULT_EVENT_KEY = "__default__";

export const useSlotSelectionState = (eventId?: string) => {
  const [selectedSlotsByEvent, setSelectedSlotsByEvent] = useAtom(slotAtom);
  const selectedEventKey = eventId || DEFAULT_EVENT_KEY;
  const selectedSlots = selectedSlotsByEvent[selectedEventKey] || [];

  const toggleSlotSelection = (slot: Slot) => {
    const isSelected = selectedSlots.some(({ id }) => id === slot.id);
    const updatedSlots = isSelected ? selectedSlots.filter((s) => s.id !== slot.id) : [...selectedSlots, slot];
    setSelectedSlotsByEvent((currentSelectedSlotsByEvent) => ({
      ...currentSelectedSlotsByEvent,
      [selectedEventKey]: updatedSlots,
    }));
  };

  const flushSlotSelection = () => {
    setSelectedSlotsByEvent((currentSelectedSlotsByEvent) => {
      const remainingSelections = { ...currentSelectedSlotsByEvent };
      delete remainingSelections[selectedEventKey];
      return remainingSelections;
    });
  };

  return {
    selectedSlots,
    toggleSlotSelection,
    flushSlotSelection,
  };
};
